<script>
import BasePublicationsFilter from '@/components/admin/collector/publications/BasePublicationsFilter.vue'

import {
  collectorPublicationsMapper as StoreMapper,
} from '../store'


export default {
  name: 'PublicationsFilter',
  extends: BasePublicationsFilter,
  computed: {
    ...StoreMapper.mapState(['events', 'sessions', 'subjects', 'procedures']),
    ...StoreMapper.mapActions(['fetchSessions', 'fetchProcedures']),
  },
}
</script>
